import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const Reports = lazy(() => import('@cobliteam/reports'));

const routes = [
  {
    path: Location.REPORTS,
    component: Reports,
    accessDeniedDescription: 'ver relatórios',
    needsGoogleMaps: true,
  },
];

export default routes;
